import API from "../api/api";
import { filterActiveResponseData } from "./activeDataUtils";


// Simple in-memory cache
let servicesCache = null;

export const getServices = async () => {
    if (servicesCache) return servicesCache;

    try {
        const response = await API.post("/service/list", {
            sEcho: 1,
            iDisplayStart: 0,
            iDisplayLength: 10,
            sSearch: "",
            iSortCol_0: 0,
            sSortDir_0: "asc",
            aaSorting: [[0, "asc"]],
            bRegex: false,
            bRegex_0: false,
            bSearchable_0: true,
            bSortable_0: true,
            mDataProp_0: 0
        });
        servicesCache = filterActiveResponseData(response.data);
        return servicesCache;
    } catch (error) {
        console.error("Error fetching services:", error);
        throw error;
    }
};

